import { connect } from "react-redux";
import { AccidentQuestions as Component } from "./AccidentQuestions";
import { getAccidentQuestionResponse } from "../../selector";
var mapStateToProps = function (state) { return ({
    response: getAccidentQuestionResponse(state),
}); };
export var AccidentQuestions = connect(mapStateToProps, {})(Component);
